import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "email-wrap bookmark-wrap" }
const _hoisted_3 = { class: "row card card-body" }
const _hoisted_4 = { class: "table-responsive product-table custom-scrollbar" }
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = { class: "row g-3" }
const _hoisted_7 = { class: "col-md-3" }
const _hoisted_8 = { class: "col-md-2" }
const _hoisted_9 = { class: "col-md-3" }
const _hoisted_10 = { class: "col-md-2" }
const _hoisted_11 = {
  class: "display table-striped table-hover table-bordered table",
  id: "basic-1"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "odd" }
const _hoisted_14 = {
  valign: "top",
  colspan: "7",
  class: "dataTables_empty"
}
const _hoisted_15 = { class: "text-muted" }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "small" }
const _hoisted_19 = { class: "text-muted" }
const _hoisted_20 = {
  key: 0,
  class: "mt-1"
}
const _hoisted_21 = {
  key: 0,
  class: "text-info"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_24 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "pagination py-2 justify-content-end pagination-primary" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "page-link" }
const _hoisted_29 = { class: "custom-modal-container" }
const _hoisted_30 = { class: "custom-modal-box" }
const _hoisted_31 = { class: "custom-modal-body" }
const _hoisted_32 = { class: "table-wrapper" }
const _hoisted_33 = {
  class: "table table-bordered table-striped",
  style: {"border":"1.5px solid #dee2e6","width":"100%","table-layout":"auto"}
}
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { style: {"border":"1.5px solid #dee2e6"} }
const _hoisted_36 = { style: {"border":"1.5px solid #dee2e6"} }
const _hoisted_37 = { style: {"border":"1.5px solid #dee2e6"} }
const _hoisted_38 = { style: {"border":"1.5px solid #dee2e6"} }
const _hoisted_39 = { style: {"border":"1.5px solid #dee2e6"} }
const _hoisted_40 = ["rowspan"]
const _hoisted_41 = ["rowspan"]
const _hoisted_42 = ["rowspan"]
const _hoisted_43 = ["rowspan"]
const _hoisted_44 = ["rowspan"]
const _hoisted_45 = { style: {"border":"2px solid #6c757d"} }
const _hoisted_46 = { style: {"border":"2px solid #6c757d"} }
const _hoisted_47 = { class: "custom-modal-footer" }
const _hoisted_48 = { class: "me-auto" }
const _hoisted_49 = { class: "custom-modal-container" }
const _hoisted_50 = { class: "custom-modal-box" }
const _hoisted_51 = { class: "custom-modal-body" }
const _hoisted_52 = { class: "mb-4 p-3 bg-light rounded" }
const _hoisted_53 = { class: "row" }
const _hoisted_54 = { class: "col-md-6" }
const _hoisted_55 = { class: "col-md-6" }
const _hoisted_56 = { class: "badge bg-success" }
const _hoisted_57 = { class: "badge bg-danger" }
const _hoisted_58 = { class: "mb-4 p-3 bg-warning bg-opacity-10 border border-warning rounded" }
const _hoisted_59 = { class: "row align-items-center" }
const _hoisted_60 = { class: "col-md-6" }
const _hoisted_61 = ["value"]
const _hoisted_62 = { class: "col-md-6" }
const _hoisted_63 = {
  key: 0,
  class: "text-success"
}
const _hoisted_64 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_65 = { class: "table-wrapper" }
const _hoisted_66 = { class: "table table-bordered table-hover" }
const _hoisted_67 = { class: "mt-4 p-3 bg-light rounded" }
const _hoisted_68 = { class: "row text-center" }
const _hoisted_69 = { class: "col-md-4" }
const _hoisted_70 = { class: "p-3 bg-white rounded shadow-sm" }
const _hoisted_71 = { class: "text-primary mb-0" }
const _hoisted_72 = { class: "col-md-4" }
const _hoisted_73 = { class: "p-3 bg-white rounded shadow-sm" }
const _hoisted_74 = { class: "text-success mb-0" }
const _hoisted_75 = { class: "col-md-4" }
const _hoisted_76 = { class: "p-3 bg-white rounded shadow-sm" }
const _hoisted_77 = { class: "text-danger mb-0" }
const _hoisted_78 = { class: "custom-modal-footer" }
const _hoisted_79 = { class: "me-auto" }
const _hoisted_80 = {
  key: 0,
  class: "text-danger small"
}
const _hoisted_81 = {
  key: 1,
  class: "text-success small"
}
const _hoisted_82 = ["disabled", "title"]
const _hoisted_83 = { class: "custom-modal-container" }
const _hoisted_84 = { class: "custom-modal-box" }
const _hoisted_85 = { class: "custom-modal-body" }
const _hoisted_86 = { class: "mb-3 p-3 bg-light rounded" }
const _hoisted_87 = { class: "row" }
const _hoisted_88 = { class: "col-md-6" }
const _hoisted_89 = { class: "col-md-6" }
const _hoisted_90 = { class: "col-md-6 mt-2" }
const _hoisted_91 = { class: "col-md-6 mt-2" }
const _hoisted_92 = { class: "mb-3 p-2 bg-light rounded d-flex gap-3" }
const _hoisted_93 = { class: "badge bg-success" }
const _hoisted_94 = { class: "badge bg-danger" }
const _hoisted_95 = { class: "badge bg-secondary" }
const _hoisted_96 = { class: "table-wrapper" }
const _hoisted_97 = { class: "table table-bordered table-hover" }
const _hoisted_98 = { key: 0 }
const _hoisted_99 = {
  colspan: "8",
  class: "text-muted text-center"
}
const _hoisted_100 = ["rowspan"]
const _hoisted_101 = ["rowspan"]
const _hoisted_102 = ["rowspan"]
const _hoisted_103 = ["rowspan"]
const _hoisted_104 = {
  class: "btn-group btn-group-sm w-100",
  role: "group"
}
const _hoisted_105 = ["name", "id", "checked", "onChange"]
const _hoisted_106 = ["for"]
const _hoisted_107 = ["name", "id", "checked", "onChange"]
const _hoisted_108 = ["for"]
const _hoisted_109 = ["value", "onInput"]
const _hoisted_110 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_111 = { class: "custom-modal-footer" }
const _hoisted_112 = { class: "me-auto" }
const _hoisted_113 = ["disabled", "title"]

import { ref, onMounted, computed } from "vue";
import * as XLSX from 'xlsx';
import { useToast } from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-default.css';

// Format date helper function

export default /*@__PURE__*/_defineComponent({
  __name: 'material-request',
  setup(__props) {

function formatDate(dateString: any) {
    if (!dateString) return '-';
    try {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return '-';
        
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        
        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const ampm = hours >= 12 ? 'PM' : 'AM';
        
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        const hoursStr = String(hours).padStart(2, '0');
        
        return `${day}/${month}/${year} ${hoursStr}:${minutes} ${ampm}`;
    } catch (error) {
        console.error('Error formatting date:', error);
        return '-';
    }
}

const allData = ref<any[]>([]);
const elementsPerPage = ref(25);
const currentPage = ref(1);
const toast = useToast();
const showEmployeeModal = ref(false);
const selectedMaterialItem = ref<any>(null);
const showActionModal = ref(false);
const selectedRequestItem = ref<any>(null);
const selectedEmployees = ref<string[]>([]);
const employeeStatusMap = ref<Record<string, { status: 'done' | 'not-done' | 'pending', reason: string }>>({});
const showPreviewModal = ref(false);
const previewData = ref<any>(null);
const mobilizersList = ref<any[]>([]);
const selectedMobilizer = ref<string>('');

const getAuthToken = () => localStorage.getItem('token');
const baseUrl = process.env.VUE_APP_BASE_URL;

onMounted(async () => {
    try {
        const token = getAuthToken();
        
        // Fetch material requests
        const response = await fetch(`${baseUrl}api/operation/frontOfficeMaterialRequest`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });

        const data = await response.json();
        console.log('API Response:', data);

        if (data && data.success && data.data) {
            allData.value = data.data;
            console.log('Data loaded successfully:', allData.value);
            if (allData.value.length === 0) {
                toast.warning('No records found');
            }
        } else {
            console.log('Invalid response structure:', data);
            toast.error('Invalid data format received');
        }

        // Fetch mobilizers list
        const mobilizersResponse = await fetch(`${baseUrl}api/all/mobilizers`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });

        const mobilizersData = await mobilizersResponse.json();
        console.log('Mobilizers Response:', mobilizersData);

        if (mobilizersData && mobilizersData.success && mobilizersData.data) {
            mobilizersList.value = mobilizersData.data;
            console.log('Mobilizers loaded successfully:', mobilizersList.value);
        }
    } catch (error) {
        console.error('API Error:', error);
        toast.error('Error fetching data');
    }
});

// Filters
const filters = ref({
    siteName: '',
    reqDate: '',
    approvedBy: '',
    status: ''
});

const filteredData = computed(() => {
    const data = Array.isArray(allData.value) ? allData.value : [];
    
    const filtered = data.filter((item: any) => {
        const includes = (str: any, query: string) => String(str || '').toLowerCase().includes(query.toLowerCase());
        
        const matchesSite = !filters.value.siteName || 
            includes(item.siteName || item.siteId?.siteName, filters.value.siteName);
            
        const matchesReqDate = !filters.value.reqDate || 
            (item.reqDate && formatDate(item.reqDate).includes(filters.value.reqDate));
            
        const matchesApprovedBy = !filters.value.approvedBy || 
            includes(item.approvedBy?.email, filters.value.approvedBy);
            
        const matchesStatus = !filters.value.status || 
            includes(item.status, filters.value.status);
        
        return matchesSite && matchesReqDate && matchesApprovedBy && matchesStatus;
    });
    
    return filtered.slice(
        (currentPage.value - 1) * elementsPerPage.value,
        currentPage.value * elementsPerPage.value
    );
});

function num_pages() {
    const data = Array.isArray(allData.value) ? allData.value : [];
    return Math.ceil(data.length / elementsPerPage.value);
}

function change_page(page: number) {
    currentPage.value = page;
}

function previousPage() {
    if (currentPage.value > 1) {
        currentPage.value--;
    }
}

function nextPage() {
    if (currentPage.value < num_pages()) {
        currentPage.value++;
    }
}

function clearFilters() {
    filters.value = {
        siteName: '',
        reqDate: '',
        approvedBy: '',
        status: ''
    };
}

function downloadExcel() {
    const formattedData = allData.value.map((item: any) => {
        const materials = item.materialItems?.map((mat: any) => {
            const employees = mat.employees?.map((emp: any) => 
                `${emp.employeeName} (${emp.size})`
            ).join(', ') || 'No employees';
            return `${mat.itemName} - Size: ${mat.size}, Qty: ${mat.quantity}, Employees: ${employees}`;
        }).join('; ') || '-';

        return {
            'Request Date': formatDate(item.reqDate),
            'Site Name': item.siteName || item.siteId?.siteName || '-',
            'Material Items & Employees': materials,
            'Approved By': item.approvedBy?.email || '-',
            'Approved Date': formatDate(item.approvedDate),
            'Status': item.status || '-'
        };
    });

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Front Office Material Requests");
    XLSX.writeFile(workbook, 'front-office-material-requests.xlsx');
}

function openEmployeeModal(materialItems: any) {
    selectedMaterialItem.value = materialItems;
    showEmployeeModal.value = true;
}

function closeEmployeeModal() {
    showEmployeeModal.value = false;
    selectedMaterialItem.value = null;
}

function getTotalEmployeeCount(materialItems: any) {
    let count = 0;
    materialItems?.forEach((item: any) => {
        count += item.employees?.length || 0;
    });
    return count;
}

function openActionModal(item: any) {
    selectedRequestItem.value = item;
    selectedEmployees.value = [];
    employeeStatusMap.value = {};
    
    // Initialize status map for all employees
    item.materialItems?.forEach((mat: any) => {
        mat.employees?.forEach((emp: any) => {
            employeeStatusMap.value[emp.employeeId._id] = {
                status: 'pending',
                reason: ''
            };
        });
    });
    
    showActionModal.value = true;
}

function closeActionModal() {
    showActionModal.value = false;
    selectedRequestItem.value = null;
    selectedEmployees.value = [];
    employeeStatusMap.value = {};
}

function toggleEmployeeSelection(employeeId: string) {
    const index = selectedEmployees.value.indexOf(employeeId);
    if (index > -1) {
        selectedEmployees.value.splice(index, 1);
    } else {
        selectedEmployees.value.push(employeeId);
    }
}

function toggleAllEmployees() {
    if (!selectedRequestItem.value?.materialItems) return;
    
    const allEmployeeIds: string[] = [];
    selectedRequestItem.value.materialItems.forEach((item: any) => {
        item.employees?.forEach((emp: any) => {
            allEmployeeIds.push(emp.employeeId._id);
        });
    });
    
    if (selectedEmployees.value.length === allEmployeeIds.length) {
        selectedEmployees.value = [];
    } else {
        selectedEmployees.value = [...allEmployeeIds];
    }
}

function isEmployeeSelected(employeeId: string) {
    return selectedEmployees.value.includes(employeeId);
}

function isAllSelected() {
    if (!selectedRequestItem.value?.materialItems) return false;
    
    const allEmployeeIds: string[] = [];
    selectedRequestItem.value.materialItems.forEach((item: any) => {
        item.employees?.forEach((emp: any) => {
            allEmployeeIds.push(emp.employeeId._id);
        });
    });
    
    return allEmployeeIds.length > 0 && selectedEmployees.value.length === allEmployeeIds.length;
}

function setEmployeeStatus(employeeId: string, status: 'done' | 'not-done') {
    if (employeeStatusMap.value[employeeId]) {
        employeeStatusMap.value[employeeId].status = status;
        if (status === 'done') {
            employeeStatusMap.value[employeeId].reason = '';
        }
    }
}

function updateEmployeeReason(employeeId: string, event: Event) {
    const target = event.target as HTMLInputElement;
    if (employeeStatusMap.value[employeeId]) {
        employeeStatusMap.value[employeeId].reason = target.value;
    }
}

function getCompletedCount() {
    return Object.values(employeeStatusMap.value).filter(emp => emp.status === 'done').length;
}

function getNotDoneCount() {
    return Object.values(employeeStatusMap.value).filter(emp => emp.status === 'not-done').length;
}

function canProceed() {
    const allEmployees = Object.values(employeeStatusMap.value);
    const hasUnprocessed = allEmployees.some(emp => emp.status === 'pending');
    const notDoneWithoutReason = allEmployees.some(emp => emp.status === 'not-done' && !emp.reason.trim());
    
    return !hasUnprocessed && !notDoneWithoutReason;
}

function handleProceed() {
    if (!canProceed()) {
        toast.error('Please complete all employee status and provide reasons for "Not Done" items');
        return;
    }
    
    // Prepare detailed preview data
    const detailedEmployees: any[] = [];
    selectedRequestItem.value.materialItems?.forEach((mat: any) => {
        mat.employees?.forEach((emp: any) => {
            const status = employeeStatusMap.value[emp.employeeId._id];
            detailedEmployees.push({
                itemName: mat.itemName,
                itemSize: mat.size,
                department: mat.department,
                employeeId: emp.employeeId._id,
                employeeName: emp.employeeName,
                employeeSize: emp.size,
                status: status.status,
                reason: status.reason
            });
        });
    });
    
    previewData.value = {
        requestId: selectedRequestItem.value._id,
        siteName: selectedRequestItem.value.siteName,
        category: selectedRequestItem.value.category,
        reqDate: selectedRequestItem.value.reqDate,
        status: selectedRequestItem.value.status,
        employees: detailedEmployees,
        summary: {
            total: Object.keys(employeeStatusMap.value).length,
            done: getCompletedCount(),
            notDone: getNotDoneCount()
        }
    };
    
    // Close action modal and open preview modal
    closeActionModal();
    showPreviewModal.value = true;
}

function closePreviewModal() {
    showPreviewModal.value = false;
    previewData.value = null;
    selectedMobilizer.value = '';
}

function updateMobilizer(event: Event) {
    const target = event.target as HTMLSelectElement;
    selectedMobilizer.value = target.value;
}

function canCreateOrder() {
    // Check if a mobilizer is selected
    return selectedMobilizer.value !== '';
}

async function createOrder() {
    if (!canCreateOrder()) {
        toast.error('Please select a mobilizer for this order');
        return;
    }

    try {
        const token = getAuthToken();
        
        // Get the selected mobilizer details
        const selectedMobilizerData = mobilizersList.value.find(m => m._id === selectedMobilizer.value);

        // Prepare employees data in the required format
        const employeesData = previewData.value.employees.map((emp: any) => ({
            itemName: emp.itemName,
            itemSize: emp.itemSize,
            employeeId: emp.employeeId,
            employeeName: emp.employeeName,
            status: emp.status,
            reason: emp.reason || ''
        }));

        const orderData = {
            frontOfficeMaterialRequestId: previewData.value.requestId,
            mobilizerId: selectedMobilizer.value,
            mobilizerName: selectedMobilizerData?.employeeName || '',
            employees: employeesData,
            summary: previewData.value.summary
        };
        
        console.log('Creating Order:', JSON.stringify(orderData, null, 2));
        
        const response = await fetch(`${baseUrl}api/operation/order-delivery`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(orderData)
        });
        
        const data = await response.json();
        
        if (data.success) {
            toast.success('Order created successfully!');
            closePreviewModal();
            // Refresh the data
            setTimeout(() => {
                location.reload();
            }, 1500);
        } else {
            toast.error(data.message || 'Failed to create order');
        }
        
    } catch (error) {
        console.error('Error creating order:', error);
        toast.error('Error creating order');
    }
}

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Front Office",
      title: "Material Request"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("form", {
              class: "no-footer",
              onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
            }, [
              _createElementVNode("div", { class: "mb-3 d-flex justify-content-end" }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-success",
                  onClick: downloadExcel
                }, [...(_cache[7] || (_cache[7] = [
                  _createElementVNode("i", { class: "fa fa-download me-2" }, null, -1),
                  _createTextVNode("Download Excel ", -1)
                ]))])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _cache[8] || (_cache[8] = _createElementVNode("label", { class: "form-label" }, "Site Name", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.value.siteName) = $event)),
                      placeholder: "Filter site name..."
                    }, null, 512), [
                      [_vModelText, filters.value.siteName]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _cache[9] || (_cache[9] = _createElementVNode("label", { class: "form-label" }, "Request Date", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.value.reqDate) = $event))
                    }, null, 512), [
                      [_vModelText, filters.value.reqDate]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _cache[10] || (_cache[10] = _createElementVNode("label", { class: "form-label" }, "Approved By", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.value.approvedBy) = $event)),
                      placeholder: "Filter approved by..."
                    }, null, 512), [
                      [_vModelText, filters.value.approvedBy]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _cache[12] || (_cache[12] = _createElementVNode("label", { class: "form-label" }, "Status", -1)),
                    _withDirectives(_createElementVNode("select", {
                      class: "form-select",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.value.status) = $event))
                    }, [...(_cache[11] || (_cache[11] = [
                      _createElementVNode("option", { value: "" }, "All", -1),
                      _createElementVNode("option", { value: "Pending" }, "Pending", -1),
                      _createElementVNode("option", { value: "Approved" }, "Approved", -1),
                      _createElementVNode("option", { value: "Rejected" }, "Rejected", -1)
                    ]))], 512), [
                      [_vModelSelect, filters.value.status]
                    ])
                  ]),
                  _createElementVNode("div", { class: "col-md-2 d-flex align-items-end" }, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-secondary w-100",
                      onClick: clearFilters
                    }, " Clear Filters ")
                  ])
                ])
              ]),
              _createElementVNode("table", _hoisted_11, [
                _cache[20] || (_cache[20] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", {
                      class: "sorting_asc",
                      scope: "col"
                    }, "SL"),
                    _createElementVNode("th", {
                      class: "sorting_asc",
                      scope: "col"
                    }, "Request Date"),
                    _createElementVNode("th", {
                      class: "sorting_asc",
                      scope: "col"
                    }, "Site Name"),
                    _createElementVNode("th", {
                      class: "sorting_asc",
                      scope: "col"
                    }, "Material Items & Employee Names (Sizes)"),
                    _createElementVNode("th", {
                      class: "sorting_asc",
                      scope: "col"
                    }, "Approved By"),
                    _createElementVNode("th", {
                      class: "sorting_asc",
                      scope: "col"
                    }, "Status"),
                    _createElementVNode("th", {
                      class: "sorting_asc",
                      scope: "col"
                    }, "Actions")
                  ])
                ], -1)),
                (!filteredData.value.length)
                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_12, [
                      _createElementVNode("tr", _hoisted_13, [
                        _createElementVNode("td", _hoisted_14, [
                          _cache[13] || (_cache[13] = _createTextVNode(" No matching records found ", -1)),
                          _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
                          _createElementVNode("small", _hoisted_15, "Debug: Total records: " + _toDisplayString(allData.value.length), 1)
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("tbody", _hoisted_16, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredData.value, (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: item._id
                        }, [
                          _createElementVNode("td", null, _toDisplayString((currentPage.value - 1) * elementsPerPage.value + index + 1), 1),
                          _createElementVNode("td", null, _toDisplayString(formatDate(item.reqDate)), 1),
                          _createElementVNode("td", null, _toDisplayString(item.siteName || item.siteId?.siteName || '-'), 1),
                          _createElementVNode("td", null, [
                            (item.materialItems?.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.materialItems.slice(0, 1), (mat, idx) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: idx,
                                      class: "mb-2"
                                    }, [
                                      _createElementVNode("div", _hoisted_18, [
                                        _createElementVNode("strong", null, _toDisplayString(mat.itemName), 1),
                                        _cache[15] || (_cache[15] = _createTextVNode(" - Size: ", -1)),
                                        _createElementVNode("strong", null, _toDisplayString(mat.size), 1),
                                        _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1)),
                                        _createElementVNode("small", _hoisted_19, "Qty: " + _toDisplayString(mat.quantity), 1),
                                        _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1)),
                                        (mat.employees?.length)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mat.employees.slice(0, 2), (emp, empIdx) => {
                                                return (_openBlock(), _createElementBlock("div", { key: empIdx }, [
                                                  _createElementVNode("small", null, "• " + _toDisplayString(emp.employeeName) + " (" + _toDisplayString(emp.size) + ")", 1)
                                                ]))
                                              }), 128)),
                                              (mat.employees.length > 2)
                                                ? (_openBlock(), _createElementBlock("small", _hoisted_21, " + " + _toDisplayString(mat.employees.length - 2) + " more employees ", 1))
                                                : _createCommentVNode("", true)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]))
                                  }), 128)),
                                  (item.materialItems.length > 1 || getTotalEmployeeCount(item.materialItems) > 2)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        class: "btn btn-link btn-sm p-0 mt-1",
                                        onClick: ($event: any) => (openEmployeeModal(item.materialItems))
                                      }, " View All (" + _toDisplayString(item.materialItems.length) + " items, " + _toDisplayString(getTotalEmployeeCount(item.materialItems)) + " employees) ", 9, _hoisted_22))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_23, "No material items"))
                          ]),
                          _createElementVNode("td", null, [
                            _createTextVNode(_toDisplayString(item.approvedBy?.email || '-') + " ", 1),
                            _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
                            (item.approvedDate)
                              ? (_openBlock(), _createElementBlock("small", _hoisted_24, _toDisplayString(formatDate(item.approvedDate)), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("span", {
                              class: _normalizeClass({
                                            'badge rounded-pill bg-success': item.status === 'Approved',
                                            'badge rounded-pill bg-warning': item.status === 'Pending',
                                            'badge rounded-pill bg-danger': item.status === 'Rejected'
                                        })
                            }, _toDisplayString(item.status || 'Unknown'), 3)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("button", {
                              class: "btn btn-primary btn-sm",
                              onClick: ($event: any) => (openActionModal(item))
                            }, [...(_cache[19] || (_cache[19] = [
                              _createElementVNode("i", { class: "fa fa-eye me-1" }, null, -1),
                              _createTextVNode("View ", -1)
                            ]))], 8, _hoisted_25)
                          ])
                        ]))
                      }), 128))
                    ]))
              ]),
              _createElementVNode("ul", _hoisted_26, [
                _createElementVNode("li", {
                  class: "page-item",
                  onClick: previousPage
                }, [...(_cache[21] || (_cache[21] = [
                  _createElementVNode("a", { class: "page-link" }, "Previous", -1)
                ]))]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(num_pages(), (i) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: _normalizeClass(["page-item", [i == currentPage.value ? 'active' : '']]),
                    key: i,
                    onClick: ($event: any) => (change_page(i))
                  }, [
                    _createElementVNode("a", _hoisted_28, _toDisplayString(i), 1)
                  ], 10, _hoisted_27))
                }), 128)),
                _createElementVNode("li", {
                  class: "page-item",
                  onClick: nextPage
                }, [...(_cache[22] || (_cache[22] = [
                  _createElementVNode("a", { class: "page-link" }, "Next", -1)
                ]))])
              ])
            ], 32)
          ])
        ])
      ])
    ]),
    (showEmployeeModal.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "custom-modal-overlay",
          onClick: _withModifiers(closeEmployeeModal, ["self"])
        }, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", { class: "custom-modal-header" }, [
                _cache[23] || (_cache[23] = _createElementVNode("h5", { class: "modal-title" }, "Material Items & Employee Details", -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close",
                  onClick: closeEmployeeModal
                })
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("table", _hoisted_33, [
                    _cache[25] || (_cache[25] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", { style: {"background-color":"#f8f9fa"} }, [
                        _createElementVNode("th", { style: {"border":"1.5px solid #dee2e6","font-weight":"600"} }, "SL"),
                        _createElementVNode("th", { style: {"border":"1.5px solid #dee2e6","font-weight":"600"} }, "Item Name"),
                        _createElementVNode("th", { style: {"border":"1.5px solid #dee2e6","font-weight":"600"} }, "Size"),
                        _createElementVNode("th", { style: {"border":"1.5px solid #dee2e6","font-weight":"600"} }, "Department"),
                        _createElementVNode("th", { style: {"border":"1.5px solid #dee2e6","font-weight":"600"} }, "Quantity"),
                        _createElementVNode("th", { style: {"border":"1.5px solid #dee2e6","font-weight":"600"} }, "Employee Name"),
                        _createElementVNode("th", { style: {"border":"1.5px solid #dee2e6","font-weight":"600"} }, "Employee Size")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedMaterialItem.value, (mat, idx) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: idx }, [
                          (!mat.employees?.length)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_34, [
                                _createElementVNode("td", _hoisted_35, _toDisplayString(idx + 1), 1),
                                _createElementVNode("td", _hoisted_36, _toDisplayString(mat.itemName), 1),
                                _createElementVNode("td", _hoisted_37, _toDisplayString(mat.size), 1),
                                _createElementVNode("td", _hoisted_38, _toDisplayString(mat.department), 1),
                                _createElementVNode("td", _hoisted_39, _toDisplayString(mat.quantity), 1),
                                _cache[24] || (_cache[24] = _createElementVNode("td", {
                                  colspan: "2",
                                  class: "text-muted",
                                  style: {"border":"1.5px solid #dee2e6"}
                                }, "No employees", -1))
                              ]))
                            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(mat.employees, (emp, empIdx) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: emp._id
                                }, [
                                  (empIdx === 0)
                                    ? (_openBlock(), _createElementBlock("td", {
                                        key: 0,
                                        rowspan: mat.employees.length,
                                        style: {"border":"2px solid #6c757d","background-color":"#f8f9fa","font-weight":"500","vertical-align":"middle"}
                                      }, _toDisplayString(idx + 1), 9, _hoisted_40))
                                    : _createCommentVNode("", true),
                                  (empIdx === 0)
                                    ? (_openBlock(), _createElementBlock("td", {
                                        key: 1,
                                        rowspan: mat.employees.length,
                                        style: {"border":"2px solid #6c757d","background-color":"#f8f9fa","font-weight":"500","vertical-align":"middle"}
                                      }, _toDisplayString(mat.itemName), 9, _hoisted_41))
                                    : _createCommentVNode("", true),
                                  (empIdx === 0)
                                    ? (_openBlock(), _createElementBlock("td", {
                                        key: 2,
                                        rowspan: mat.employees.length,
                                        style: {"border":"2px solid #6c757d","background-color":"#f8f9fa","font-weight":"500","vertical-align":"middle"}
                                      }, _toDisplayString(mat.size), 9, _hoisted_42))
                                    : _createCommentVNode("", true),
                                  (empIdx === 0)
                                    ? (_openBlock(), _createElementBlock("td", {
                                        key: 3,
                                        rowspan: mat.employees.length,
                                        style: {"border":"2px solid #6c757d","background-color":"#f8f9fa","font-weight":"500","vertical-align":"middle"}
                                      }, _toDisplayString(mat.department), 9, _hoisted_43))
                                    : _createCommentVNode("", true),
                                  (empIdx === 0)
                                    ? (_openBlock(), _createElementBlock("td", {
                                        key: 4,
                                        rowspan: mat.employees.length,
                                        style: {"border":"2px solid #6c757d","background-color":"#f8f9fa","font-weight":"500","vertical-align":"middle"}
                                      }, _toDisplayString(mat.quantity), 9, _hoisted_44))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("td", _hoisted_45, _toDisplayString(emp.employeeName), 1),
                                  _createElementVNode("td", _hoisted_46, _toDisplayString(emp.size), 1)
                                ]))
                              }), 128))
                        ], 64))
                      }), 128))
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("strong", null, "Total Items: " + _toDisplayString(selectedMaterialItem.value?.length || 0) + " | Total Employees: " + _toDisplayString(getTotalEmployeeCount(selectedMaterialItem.value)), 1)
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary",
                  onClick: closeEmployeeModal
                }, "Close")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (showPreviewModal.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "custom-modal-overlay",
          onClick: _withModifiers(closePreviewModal, ["self"])
        }, [
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("div", { class: "custom-modal-header" }, [
                _cache[26] || (_cache[26] = _createElementVNode("h5", { class: "modal-title" }, "Order Preview", -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close",
                  onClick: closePreviewModal
                })
              ]),
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _cache[35] || (_cache[35] = _createElementVNode("h6", { class: "mb-3 fw-bold" }, "Order Summary", -1)),
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("p", null, [
                        _cache[27] || (_cache[27] = _createElementVNode("strong", null, "Site:", -1)),
                        _createTextVNode(" " + _toDisplayString(previewData.value?.siteName), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _cache[28] || (_cache[28] = _createElementVNode("strong", null, "Category:", -1)),
                        _createTextVNode(" " + _toDisplayString(previewData.value?.category), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _cache[29] || (_cache[29] = _createElementVNode("strong", null, "Request Date:", -1)),
                        _createTextVNode(" " + _toDisplayString(formatDate(previewData.value?.reqDate)), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_55, [
                      _createElementVNode("p", null, [
                        _cache[30] || (_cache[30] = _createElementVNode("strong", null, "Total Employees:", -1)),
                        _createTextVNode(" " + _toDisplayString(previewData.value?.summary.total), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _cache[31] || (_cache[31] = _createElementVNode("strong", null, "Completed:", -1)),
                        _cache[32] || (_cache[32] = _createTextVNode()),
                        _createElementVNode("span", _hoisted_56, _toDisplayString(previewData.value?.summary.done), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _cache[33] || (_cache[33] = _createElementVNode("strong", null, "Not Done:", -1)),
                        _cache[34] || (_cache[34] = _createTextVNode()),
                        _createElementVNode("span", _hoisted_57, _toDisplayString(previewData.value?.summary.notDone), 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_58, [
                  _cache[40] || (_cache[40] = _createElementVNode("h6", { class: "mb-3 fw-bold" }, [
                    _createElementVNode("i", { class: "fa fa-user me-2" }),
                    _createTextVNode("Select Mobilizer for this Order ")
                  ], -1)),
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("div", _hoisted_60, [
                      _withDirectives(_createElementVNode("select", {
                        class: "form-select",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedMobilizer).value = $event)),
                        onChange: _cache[6] || (_cache[6] = ($event: any) => (updateMobilizer($event))),
                        required: ""
                      }, [
                        _cache[36] || (_cache[36] = _createElementVNode("option", { value: "" }, "-- Select a Mobilizer --", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mobilizersList.value, (mobilizer) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: mobilizer._id,
                            value: mobilizer._id
                          }, _toDisplayString(mobilizer.employeeName), 9, _hoisted_61))
                        }), 128))
                      ], 544), [
                        [_vModelSelect, selectedMobilizer.value]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_62, [
                      (selectedMobilizer.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_63, [
                            _cache[37] || (_cache[37] = _createElementVNode("i", { class: "fa fa-check-circle me-1" }, null, -1)),
                            _cache[38] || (_cache[38] = _createTextVNode(" Mobilizer selected: ", -1)),
                            _createElementVNode("strong", null, _toDisplayString(mobilizersList.value.find(m => m._id === selectedMobilizer.value)?.employeeName), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_64, [...(_cache[39] || (_cache[39] = [
                            _createElementVNode("i", { class: "fa fa-exclamation-circle me-1" }, null, -1),
                            _createTextVNode(" Please select a mobilizer ", -1)
                          ]))]))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_65, [
                  _cache[42] || (_cache[42] = _createElementVNode("h6", { class: "mb-3 fw-bold" }, "Employee Details", -1)),
                  _createElementVNode("table", _hoisted_66, [
                    _cache[41] || (_cache[41] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", { style: {"background-color":"#f8f9fa"} }, [
                        _createElementVNode("th", null, "SL"),
                        _createElementVNode("th", null, "Item Name"),
                        _createElementVNode("th", null, "Item Size"),
                        _createElementVNode("th", null, "Department"),
                        _createElementVNode("th", null, "Employee Name"),
                        _createElementVNode("th", null, "Employee Size"),
                        _createElementVNode("th", null, "Status"),
                        _createElementVNode("th", null, "Reason")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(previewData.value?.employees, (emp, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: index,
                          class: _normalizeClass({
                                        'table-success': emp.status === 'done',
                                        'table-danger': emp.status === 'not-done'
                                    })
                        }, [
                          _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                          _createElementVNode("td", null, _toDisplayString(emp.itemName), 1),
                          _createElementVNode("td", null, _toDisplayString(emp.itemSize), 1),
                          _createElementVNode("td", null, _toDisplayString(emp.department), 1),
                          _createElementVNode("td", null, _toDisplayString(emp.employeeName), 1),
                          _createElementVNode("td", null, _toDisplayString(emp.employeeSize), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("span", {
                              class: _normalizeClass({
                                            'badge bg-success': emp.status === 'done',
                                            'badge bg-danger': emp.status === 'not-done'
                                        })
                            }, _toDisplayString(emp.status === 'done' ? 'Done' : 'Not Done'), 3)
                          ]),
                          _createElementVNode("td", null, _toDisplayString(emp.reason || '-'), 1)
                        ], 2))
                      }), 128))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_67, [
                  _cache[46] || (_cache[46] = _createElementVNode("h6", { class: "mb-3 fw-bold" }, "Order Statistics", -1)),
                  _createElementVNode("div", _hoisted_68, [
                    _createElementVNode("div", _hoisted_69, [
                      _createElementVNode("div", _hoisted_70, [
                        _createElementVNode("h3", _hoisted_71, _toDisplayString(previewData.value?.summary.total), 1),
                        _cache[43] || (_cache[43] = _createElementVNode("small", { class: "text-muted" }, "Total Employees", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_72, [
                      _createElementVNode("div", _hoisted_73, [
                        _createElementVNode("h3", _hoisted_74, _toDisplayString(previewData.value?.summary.done), 1),
                        _cache[44] || (_cache[44] = _createElementVNode("small", { class: "text-muted" }, "Completed", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_75, [
                      _createElementVNode("div", _hoisted_76, [
                        _createElementVNode("h3", _hoisted_77, _toDisplayString(previewData.value?.summary.notDone), 1),
                        _cache[45] || (_cache[45] = _createElementVNode("small", { class: "text-muted" }, "Not Done", -1))
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_78, [
                _createElementVNode("div", _hoisted_79, [
                  (!canCreateOrder())
                    ? (_openBlock(), _createElementBlock("span", _hoisted_80, [...(_cache[47] || (_cache[47] = [
                        _createElementVNode("i", { class: "fa fa-exclamation-triangle me-1" }, null, -1),
                        _createTextVNode("Please select a mobilizer for this order ", -1)
                      ]))]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_81, [...(_cache[48] || (_cache[48] = [
                        _createElementVNode("i", { class: "fa fa-check-circle me-1" }, null, -1),
                        _createTextVNode("Mobilizer selected ", -1)
                      ]))]))
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary me-2",
                  onClick: closePreviewModal
                }, [...(_cache[49] || (_cache[49] = [
                  _createElementVNode("i", { class: "fa fa-times me-1" }, null, -1),
                  _createTextVNode("Cancel ", -1)
                ]))]),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-success",
                  onClick: createOrder,
                  disabled: !canCreateOrder(),
                  title: !canCreateOrder() ? 'Please select a mobilizer for this order' : ''
                }, [...(_cache[50] || (_cache[50] = [
                  _createElementVNode("i", { class: "fa fa-shopping-cart me-1" }, null, -1),
                  _createTextVNode("Create Order ", -1)
                ]))], 8, _hoisted_82)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (showActionModal.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "custom-modal-overlay",
          onClick: _withModifiers(closeActionModal, ["self"])
        }, [
          _createElementVNode("div", _hoisted_83, [
            _createElementVNode("div", _hoisted_84, [
              _createElementVNode("div", { class: "custom-modal-header" }, [
                _cache[51] || (_cache[51] = _createElementVNode("h5", { class: "modal-title" }, "Employee Selection", -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close",
                  onClick: closeActionModal
                })
              ]),
              _createElementVNode("div", _hoisted_85, [
                _createElementVNode("div", _hoisted_86, [
                  _createElementVNode("div", _hoisted_87, [
                    _createElementVNode("div", _hoisted_88, [
                      _cache[52] || (_cache[52] = _createElementVNode("strong", null, "Site:", -1)),
                      _createTextVNode(" " + _toDisplayString(selectedRequestItem.value?.siteName), 1)
                    ]),
                    _createElementVNode("div", _hoisted_89, [
                      _cache[53] || (_cache[53] = _createElementVNode("strong", null, "Request Date:", -1)),
                      _createTextVNode(" " + _toDisplayString(formatDate(selectedRequestItem.value?.reqDate)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_90, [
                      _cache[54] || (_cache[54] = _createElementVNode("strong", null, "Status:", -1)),
                      _createElementVNode("span", {
                        class: _normalizeClass({
                                    'badge rounded-pill bg-success': selectedRequestItem.value?.status === 'Approved',
                                    'badge rounded-pill bg-warning': selectedRequestItem.value?.status === 'Pending',
                                    'badge rounded-pill bg-danger': selectedRequestItem.value?.status === 'Rejected'
                                })
                      }, _toDisplayString(selectedRequestItem.value?.status), 3)
                    ]),
                    _createElementVNode("div", _hoisted_91, [
                      _cache[55] || (_cache[55] = _createElementVNode("strong", null, "Category:", -1)),
                      _createTextVNode(" " + _toDisplayString(selectedRequestItem.value?.category), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_92, [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_93, "Done: " + _toDisplayString(getCompletedCount()), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_94, "Not Done: " + _toDisplayString(getNotDoneCount()), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_95, "Pending: " + _toDisplayString(getTotalEmployeeCount(selectedRequestItem.value?.materialItems) - getCompletedCount() - getNotDoneCount()), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_96, [
                  _createElementVNode("table", _hoisted_97, [
                    _cache[58] || (_cache[58] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", { style: {"background-color":"#f8f9fa"} }, [
                        _createElementVNode("th", null, "SL"),
                        _createElementVNode("th", null, "Item Name"),
                        _createElementVNode("th", null, "Size"),
                        _createElementVNode("th", null, "Department"),
                        _createElementVNode("th", null, "Employee Name"),
                        _createElementVNode("th", null, "Employee Size"),
                        _createElementVNode("th", { style: {"width":"200px"} }, "Status"),
                        _createElementVNode("th", { style: {"width":"250px"} }, "Reason (If Not Done)")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedRequestItem.value?.materialItems, (mat, idx) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: idx }, [
                          (!mat.employees?.length)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_98, [
                                _createElementVNode("td", _hoisted_99, "No employees for " + _toDisplayString(mat.itemName), 1)
                              ]))
                            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(mat.employees, (emp, empIdx) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: emp.employeeId._id,
                                  class: _normalizeClass({
                                            'table-success': employeeStatusMap.value[emp.employeeId._id]?.status === 'done',
                                            'table-danger': employeeStatusMap.value[emp.employeeId._id]?.status === 'not-done'
                                        })
                                }, [
                                  (empIdx === 0)
                                    ? (_openBlock(), _createElementBlock("td", {
                                        key: 0,
                                        rowspan: mat.employees.length,
                                        style: {"vertical-align":"middle","background-color":"#f8f9fa","font-weight":"500"}
                                      }, _toDisplayString(idx + 1), 9, _hoisted_100))
                                    : _createCommentVNode("", true),
                                  (empIdx === 0)
                                    ? (_openBlock(), _createElementBlock("td", {
                                        key: 1,
                                        rowspan: mat.employees.length,
                                        style: {"vertical-align":"middle","background-color":"#f8f9fa","font-weight":"500"}
                                      }, _toDisplayString(mat.itemName), 9, _hoisted_101))
                                    : _createCommentVNode("", true),
                                  (empIdx === 0)
                                    ? (_openBlock(), _createElementBlock("td", {
                                        key: 2,
                                        rowspan: mat.employees.length,
                                        style: {"vertical-align":"middle","background-color":"#f8f9fa","font-weight":"500"}
                                      }, _toDisplayString(mat.size), 9, _hoisted_102))
                                    : _createCommentVNode("", true),
                                  (empIdx === 0)
                                    ? (_openBlock(), _createElementBlock("td", {
                                        key: 3,
                                        rowspan: mat.employees.length,
                                        style: {"vertical-align":"middle","background-color":"#f8f9fa","font-weight":"500"}
                                      }, _toDisplayString(mat.department), 9, _hoisted_103))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("td", null, _toDisplayString(emp.employeeName), 1),
                                  _createElementVNode("td", null, _toDisplayString(emp.size), 1),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("div", _hoisted_104, [
                                      _createElementVNode("input", {
                                        type: "radio",
                                        class: "btn-check",
                                        name: `status-${emp.employeeId._id}`,
                                        id: `done-${emp.employeeId._id}`,
                                        checked: employeeStatusMap.value[emp.employeeId._id]?.status === 'done',
                                        onChange: ($event: any) => (setEmployeeStatus(emp.employeeId._id, 'done'))
                                      }, null, 40, _hoisted_105),
                                      _createElementVNode("label", {
                                        class: "btn btn-outline-success",
                                        for: `done-${emp.employeeId._id}`
                                      }, [...(_cache[56] || (_cache[56] = [
                                        _createElementVNode("i", { class: "fa fa-check" }, null, -1),
                                        _createTextVNode(" Done ", -1)
                                      ]))], 8, _hoisted_106),
                                      _createElementVNode("input", {
                                        type: "radio",
                                        class: "btn-check",
                                        name: `status-${emp.employeeId._id}`,
                                        id: `not-done-${emp.employeeId._id}`,
                                        checked: employeeStatusMap.value[emp.employeeId._id]?.status === 'not-done',
                                        onChange: ($event: any) => (setEmployeeStatus(emp.employeeId._id, 'not-done'))
                                      }, null, 40, _hoisted_107),
                                      _createElementVNode("label", {
                                        class: "btn btn-outline-danger",
                                        for: `not-done-${emp.employeeId._id}`
                                      }, [...(_cache[57] || (_cache[57] = [
                                        _createElementVNode("i", { class: "fa fa-times" }, null, -1),
                                        _createTextVNode(" Not Done ", -1)
                                      ]))], 8, _hoisted_108)
                                    ])
                                  ]),
                                  _createElementVNode("td", null, [
                                    (employeeStatusMap.value[emp.employeeId._id]?.status === 'not-done')
                                      ? (_openBlock(), _createElementBlock("input", {
                                          key: 0,
                                          type: "text",
                                          class: "form-control form-control-sm",
                                          placeholder: "Enter reason...",
                                          value: employeeStatusMap.value[emp.employeeId._id]?.reason,
                                          onInput: ($event: any) => (updateEmployeeReason(emp.employeeId._id, $event)),
                                          required: ""
                                        }, null, 40, _hoisted_109))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_110, "-"))
                                  ])
                                ], 2))
                              }), 128))
                        ], 64))
                      }), 128))
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_111, [
                _createElementVNode("div", _hoisted_112, [
                  _createElementVNode("strong", null, "Total: " + _toDisplayString(getTotalEmployeeCount(selectedRequestItem.value?.materialItems)) + " | Done: " + _toDisplayString(getCompletedCount()) + " | Not Done: " + _toDisplayString(getNotDoneCount()), 1)
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary me-2",
                  onClick: closeActionModal
                }, "Cancel"),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-success",
                  onClick: handleProceed,
                  disabled: !canProceed(),
                  title: !canProceed() ? 'Please complete all employee status and provide reasons for Not Done items' : ''
                }, [...(_cache[59] || (_cache[59] = [
                  _createElementVNode("i", { class: "fa fa-check me-1" }, null, -1),
                  _createTextVNode("Proceed ", -1)
                ]))], 8, _hoisted_113)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})